var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallHeadphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17676 8.34611C7.85988 7.79897 9.95712 5.49957 11.2248 3.16211C12.8872 4.88059 15.6636 6.52563 18.2431 6.52563C19.8796 6.52563 21.4158 6.09526 22.7448 5.34213",
    stroke: "#B7CCFF",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4727 18.1379C26.0826 17.9659 27.3527 15.9686 27.3527 13.5301C27.3527 11.0912 26.0826 9.09386 24.4727 8.92188V18.1379Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3922 25.625C15.1874 25.625 15.8321 26.2698 15.8321 27.065C15.8321 27.8602 15.1874 28.505 14.3922 28.505C13.5969 28.505 12.9521 27.8602 12.9521 27.065C12.9521 26.2698 13.5969 25.625 14.3922 25.625Z",
    fill: "#A020FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6231 26.551C18.4501 26.2783 20.3011 25.6392 21.5454 24.3926C23.0908 22.8447 24.295 20.2202 24.295 17.8729V9.88633C24.295 7.53895 23.0908 5.15899 21.5454 3.61138C20.0002 2.06329 17.6237 0.857422 15.2801 0.857422H14.1106C11.7668 0.857422 9.39065 2.06329 7.84548 3.61138C6.30006 5.15899 5.17676 6.57405 5.17676 8.92142",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39029 18.0236C3.17797 17.8537 1.43262 15.8812 1.43262 13.4729C1.43262 11.0643 3.17797 9.09173 5.39029 8.92188V18.0236Z",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4727 18.0236C26.685 17.8537 28.4303 15.8812 28.4303 13.4729C28.4303 11.0643 26.685 9.09173 24.4727 8.92188V18.0236Z",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6818 24.6348C15.7486 24.6348 16.6135 25.5011 16.6135 26.5696C16.6135 27.6381 15.7486 28.5044 14.6818 28.5044C13.615 28.5044 12.75 27.6381 12.75 26.5696C12.75 25.5011 13.615 24.6348 14.6818 24.6348Z",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9248 9.13803C7.75639 8.55996 10.137 6.73913 11.4748 4.26953C13.2292 6.08516 15.688 7.21464 18.4103 7.21464C20.1373 7.21464 21.7585 6.75994 23.161 5.96423",
    stroke: "#081E54",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallHeadphone);
export default __webpack_public_path__ + "static/media/CallHeadphone.0aac5c988cdbfc2c43152af788d7a1e7.svg";
export { ForwardRef as ReactComponent };